import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=0cdcbbd8&scoped=true&lang=pug"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"
import style0 from "./Error404.vue?vue&type=style&index=0&id=0cdcbbd8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdcbbd8",
  null
  
)

export default component.exports